import { useEffect } from "react";
import { setTokenProvider } from "@/api/client";
import { useAccessToken } from "./useAccessToken";

/**
 * Mounted inside MsalProvider. Pushes the MSAL-backed token getter into the global apiFetch
 * client so every fetch gets a fresh `Authorization: Bearer ...` header. Restores the no-op
 * provider on unmount (defensive — main.tsx never unmounts this, but if MSAL toggles at runtime
 * it'd matter).
 */
export function TokenProviderWiring() {
  const getAccessToken = useAccessToken();
  useEffect(() => {
    setTokenProvider(getAccessToken);
    return () => setTokenProvider(async () => null);
  }, [getAccessToken]);
  return null;
}
